/* © CNES */
/**
 * API configuration for current node environment. Computed from config script, served outside main bundle
 */
export const apiConfiguration: {
  apiBaseUrl: string;
  apiCatalog: string;
  geoserverUrl: string;
  authentication: {
    client: string;
    realm: string;
    url: string;
  };
  matomo: {
    url: string;
    siteId: number;
  };
  catalogBaseUrl: string;
} = {
  apiBaseUrl: `${window.__RUNTIME_CONFIG__?.API_BASE_URL}`,
  apiCatalog: '',
  geoserverUrl: `${window.__RUNTIME_CONFIG__?.GEOSERVER_URL}`, 
  
  catalogBaseUrl: `${window.__RUNTIME_CONFIG__?.CATALOG_BASE_URL}`,
  authentication: {
    client: `${window.__RUNTIME_CONFIG__?.API_CLIENT}`,
    realm: `${window.__RUNTIME_CONFIG__?.API_REALM}`,
    url: `${window.__RUNTIME_CONFIG__?.API_BASE_URL}${window.__RUNTIME_CONFIG__?.API_AUTH_URL}`,
  },
  matomo: {
    url: `${window.__RUNTIME_CONFIG__?.MATOMO_URL}`,
    siteId: parseInt(`${window.__RUNTIME_CONFIG__?.MATOMO_SITE_ID}`, 10),
  },
};
